// extracted by mini-css-extract-plugin
module.exports = {"list":"PropertyList_list__Uspex"};